import { createContext, useContext } from 'react';
export const ThemeProviderContext = createContext(undefined);
export const useThemeContext = () => {
    const ctx = useContext(ThemeProviderContext);
    if (!ctx) {
        throw new Error('useTheme cannot be used without a ThemeProvider');
    }
    return ctx;
};
//# sourceMappingURL=ThemeProviderContext.js.map